import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { CurrencyFormatter } from "../utils/CurrencyFormatter";
import { tenderedAmount, setPaymentMethod, purchaserName } from "../redux/cart";
import { useDispatch, useSelector } from "react-redux";
export default function CheckOutDialog({
  open,
  toggleCart,
  checkOutEvent,
  emptyCart,
  items,
  setPrintReceipt,
  printReceipt,
  removeItemFromCart,
  increaseCartItemQuantity,
  decreaseCartItemQuantity,
}) {
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);
  return (
    <div>
      <Dialog
        open={open}
        onClose={toggleCart}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Check out</DialogTitle>
        <DialogContent className="check-out-info-container">
          <table className="check-out-item-container">
            <thead className="check-out-thead">
              <tr className="check-out-tr">
                <th className="check-out-th">Name of item(s)</th>
                <th className="check-out-th">Qty</th>
                <th className="check-out-th">Tot.</th>
                <th className="check-out-th">Action</th>
              </tr>
            </thead>
            <tbody className="check-out-tbody">
              {items?.map((item, index) => (
                <tr className="check-out-tr" key={index}>
                  <td className="check-out-td">{item.item_name}</td>
                  <td className="item-quantity-container check-out-td">
                    <span
                      className="cart-item-quantity-btn btn-dec"
                      onClick={() => decreaseCartItemQuantity(item.item_id)}
                    >
                      -
                    </span>
                    {item.quantity}
                    <span
                      className="cart-item-quantity-btn btn-inc"
                      onClick={() => increaseCartItemQuantity(item.item_id)}
                    >
                      +
                    </span>
                  </td>
                  <td className="check-out-td">{item.cost}</td>
                  <td>
                    <Close
                      className="close"
                      onClick={() => removeItemFromCart(item?.item_id)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr className="check-out-tr">
                <td className="check-out-td">Total</td>
                <td className="check-out-td">
                  {CurrencyFormatter(items?.reduce((a, b) => a + b?.cost, 0))}
                </td>
              </tr>
              <tr className="check-out-tr">
                <td className="check-out-td">Tendered</td>
                <td className="check-out-td">
                  {CurrencyFormatter(cart?.tendered)}
                </td>
              </tr>
              <tr className="check-out-tr">
                <td className="check-out-td">Change</td>
                <td className="check-out-td">
                  {CurrencyFormatter(
                    cart?.tendered - items?.reduce((a, b) => a + b?.cost, 0)
                  )}
                </td>
              </tr>
            </tfoot>
          </table>
        </DialogContent>
        <DialogContent className="receipt-data-container">
          <div className="receipt-data-sub-container">
            Print receipt:
            <input
              type="checkbox"
              checked={printReceipt}
              value={printReceipt}
              onChange={() => setPrintReceipt(!printReceipt)}
            />
          </div>
          <div className="receipt-data-sub-container">
            <input
              className="checkout-amount"
              type="number"
              placeholder="Amount Given"
              onChange={(e) => dispatch(tenderedAmount(e.target.value))}
              min={0}
            />
          </div>
          <div className="receipt-data-sub-container">
            <input
              className="checkout-amount"
              type="text"
              placeholder="Purchaser's Name"
              onChange={(e) => dispatch(purchaserName(e.target.value))}
              min={0}
            />
          </div>
          <div className="receipt-data-sub-container">
            <label htmlFor="payment-method">Select Payment Method</label>
            <select
              id="payment-method"
              onChange={(e) => dispatch(setPaymentMethod(e.target.value))}
            >
              <option value="Cash">Cash</option>
              <option value="Mobile Money">Mobile Money</option>
              <option value="Bank Transfer">Bank Transfer</option>
              <option value="Credit">Credit</option>
            </select>
          </div>
        </DialogContent>
        <DialogActions>
          <Button className="btn" onClick={toggleCart}>
            close cart
          </Button>
          <Button className="btn" onClick={emptyCart}>
            Empty cart
          </Button>
          <Button onClick={checkOutEvent}>Check out now</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
